import * as yup from 'yup';
import {
  ISubscriptionAuthorizedPerson,
  ISubscriptionContactPersonBilling,
  ISubscriptionPropertyAddress,
  ISubscriptionPropertyDetails,
  // ISubscriptionLicense,
  ISubscription,
  ISubscriptionProduct,
  PRODUCT_KEY_MAP,
  ISubscriptionProductCode,
  PRODUCT_CODE_MAP,
  ISubscriptionPlan,
} from '../interfaces/form.interface';
// import moment from 'moment';
import { regex } from '@utils/format';

const propertyAddressSchema: yup.ObjectSchema<ISubscriptionPropertyAddress> =
  yup.object().shape({
    // buildingNumber: yup
    //   .string()
    //   .required('Building No. is required')
    //   .min(1, 'Building No. must have at least 1 character'),
    // subStreet: yup.string().optional(), // Optional field
    // street: yup
    //   .string()
    //   .required('Street is required')
    //   .min(2, 'Street must have at least 2 characters'),
    // barangay: yup
    //   .string()
    //   .required('Barangay is required')
    //   .min(2, 'Barangay must have at least 2 characters'),
    // city: yup
    //   .string()
    //   .required('City is required')
    //   .min(2, 'City must have at least 2 characters'),
    details: yup.string(),
    province: yup
      .string()
      .required('Province is required')
      .min(2, 'Province must have at least 2 characters'),
    // zipCode: yup
    //   .string()
    //   .required('Zip code is required')
    //   .matches(/^[0-9]{4}$/, 'Zip code must be exactly 4 digits'),
    country: yup
      .string()
      .required('Country is required')
      .min(2, 'Country must have at least 2 characters'),
  });

const propertyDetailsSchema: yup.ObjectSchema<ISubscriptionPropertyDetails> =
  yup.object().shape({
    propertyName: yup.string().required('Property Name is required'),
    address: propertyAddressSchema,
    // logo: yup
    //   .mixed<File[]>()
    //   .required('Logo is required')
    //   .test('fileSize', 'Logo is required', (value) => {
    //     return !!value.length;
    //   })
    //   .test('fileSize', 'The file is too large', (value) => {
    //     return value?.[0]?.size <= 2000000;
    //   })
    //   .test('fileType', 'Unsupported File Format', (value) => {
    //     return (
    //       value &&
    //       value[0] &&
    //       ['image/jpeg', 'image/png', 'image/gif'].includes(value[0].type)
    //     );
    //   }),
    emailAddress: yup
      .string()
      .email('Invalid email format')
      .matches(regex.email, 'Invalid email format')
      .required('Email Address is required'),
    website: yup
      .string()
      .matches(regex.websiteNotRequired, 'Invalid URL format'),
    tin: yup
      .string()
      .matches(
        regex.tinNotRequired,
        'TIN must be in the format XXX-XXX-XXX-XXX',
      ),
    phoneNumber: yup
      .string()
      .matches(
        regex.phoneNumberNotRequired,
        'Phone number is invalid. Number must be in international format.',
      ),
  });

// Authorized Person (Admin) Validation Schema
export const authorizedPersonSchema: yup.ObjectSchema<ISubscriptionAuthorizedPerson> =
  yup.object().shape({
    firstName: yup.string().required('First Name is required'),
    lastName: yup.string().required('Last Name is required'),
    middleName: yup.string(),
    email: yup
      .string()
      .email('Invalid email format')
      .matches(regex.email, 'Invalid email format')
      .required('Email is required'),
    phoneNumber: yup
      .string()
      .required('Phone number is required')
      .matches(
        regex.phoneNumber,
        'Phone number is invalid. Number must be in international format.',
      ),
  });

// Contact Person Billing Validation Schema
const contactPersonBillingSchema: yup.ObjectSchema<ISubscriptionContactPersonBilling> =
  yup.object().shape({
    firstName: yup.string(),
    lastName: yup.string(),
    middleName: yup.string(),
    email: yup
      .string()
      .email('Invalid email format')
      .matches(regex.email, 'Invalid email format'),
    phoneNumber: yup
      .string()
      .matches(
        regex.phoneNumberNotRequired,
        'Phone number is invalid. Number must be in international format.',
      ),
  });

// license Validation Schema
// const licenseSchema: yup.ObjectSchema<ISubscriptionLicense> = yup
//   .object()
//   .shape({
//     numberOfRooms: yup
//       .number()
//       .required('Tier Selection is required')
//       .positive('Tier Selection must be positive')
//       .integer('Tier Selection must be an integer'),
//     numberOfUsers: yup
//       .number()
//       .required('Number of Users is required')
//       .positive('Number of Users must be positive')
//       .integer('Number of Users must be an integer'),
//     concurrentUsers: yup
//       .number()
//       .required('Number of Valid Days is required')
//       .positive('Number of Valid Days must be positive')
//       .integer('Number of Valid Days must be an integer'),
//     validity: yup
//       .number()
//       .required('Number of Valid Days is required')
//       .positive('Number of Valid Days must be positive')
//       .integer('Number of Valid Days must be an integer')
//       .min(
//         moment().add(3, 'months').diff(moment(), 'days'),
//         `Number of Valid Days must be at least ${moment().add(3, 'months').diff(moment(), 'days')}`,
//       ),
//   });
const selectedProductSchema = yup
  .object({
    productName: yup
      .mixed<ISubscriptionProduct>()
      .oneOf(Object.values(PRODUCT_KEY_MAP))
      .required(),

    productCode: yup
      .mixed<ISubscriptionProductCode>()
      .oneOf(Object.values(PRODUCT_CODE_MAP))
      .required(),

    numberOfRooms: yup.number().when('productName', {
      is: PRODUCT_KEY_MAP.xeniaCloudFOS,
      then: (schema) => schema.required('Number of rooms is required').min(1),
      otherwise: (schema) => schema.strip(),
    }),

    numberOfOutlets: yup.number().when('productName', {
      is: PRODUCT_KEY_MAP.iServeCloud,
      then: (schema) => schema.required('Number of outlet is required').min(1),
      otherwise: (schema) => schema.strip(),
    }),
  })
  .required();
// Complete Payment Portal Validation Schema
const paymentPortalSchema: yup.ObjectSchema<ISubscription> = yup
  .object({
    id: yup.string().optional(),
    url: yup.string().optional(),
    sameAsAuthorized: yup.boolean().optional(),
    numberOfLicenses: yup.number().optional(),
    propertyDetails: propertyDetailsSchema.required(),
    authorizedPerson: authorizedPersonSchema.required(),
    contactPersonBilling: contactPersonBillingSchema.required(),
    // license: licenseSchema.required(),
    selectedProducts: yup
      .array()
      .of(selectedProductSchema)
      .required()
      .min(1)
      .default([]),
    initialSelected: yup
      .object({
        xeniaCloudFOS: yup.boolean().defined().default(false),
        iServeCloud: yup.boolean().defined().default(false),
        onlineBookingChannel: yup.boolean().defined().default(false),
        hermesCloudBookkeeping: yup.boolean().defined().default(false),
        hermesCloudBookkeepingCAS: yup.boolean().defined().default(false),
      })
      .defined()
      .test('at-least-one-selected', 'Select at least one product', (value) =>
        Object.values(value).some(Boolean),
      ),
    plan: yup
      .mixed<ISubscriptionPlan>()
      .oneOf(['Monthly', 'Quarterly', 'Annually'])
      .required(),
  })
  .required();

export default paymentPortalSchema;
